module.exports = __webpack_public_path__ + "img/modal-arrow.9d82938e.svg";